import { useEffect } from "react";
import { HallOfFameGameDto } from "dtos/hall-of-fame/HallOfFameGameDto";
import { HallOfFameGameCard } from "components/discover/HallOfFameGameCard";
import { Pagination } from "components/Pagination";
import { usePaging } from "hooks/usePaging";

export const PaginatedHallOfFameGamesList = (props: { games: Array<HallOfFameGameDto>; pageSize?: number }) => {
    const { games, pageSize = 24 } = props;

    const {
        currentPage,
        totalPages,
        goToPage,
        canGoNext,
        canGoPrevious,
        pagedItems: currentGames,
        resetPaging,
    } = usePaging({
        items: games,
        pageSize,
    });

    // Reset pagination when games change
    useEffect(() => {
        resetPaging();
    }, [resetPaging, games]);

    if (games.length === 0) {
        return null;
    }

    return (
        <div className="vstack gap-4">
            <div className="hstack gap-3 justify-content-between">
                <h2 className="h4">Games ({games.length})</h2>

                {games.length > pageSize && (
                    <div className="d-flex justify-content-end align-self-end">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={goToPage}
                            canGoNext={canGoNext}
                            canGoPrevious={canGoPrevious}
                        />
                    </div>
                )}
            </div>

            <div className="row g-3">
                {currentGames.map(game => (
                    <div key={game.code} className="col-12 col-md-6 col-xl-4">
                        <HallOfFameGameCard game={game} />
                    </div>
                ))}
            </div>

            <div className="hstack gap-3 justify-content-end">
                {games.length > pageSize && (
                    <div className="d-flex justify-content-end align-self-end">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={goToPage}
                            canGoNext={canGoNext}
                            canGoPrevious={canGoPrevious}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
